import { graphql } from "react-relay";

export const AddOwnerProfileMutation = graphql`
  mutation AddOwnerProfileMutation(
    $connections: [ID!]!
    $resourceOwnerProfileInput: ResourceOwnerConfigurationInput!
    $accountOwnerProfileInput: AccountOwnersConfigurationInput!
  ) {
    addAccountOwnersProfile(input: $accountOwnerProfileInput) {
      configuration {
        profile
        record {
          ... on AccountOwnersConfiguration {
            default {
              owners
            }
            tags
          }
        }
      }
    }
    addResourceOwnerProfile(input: $resourceOwnerProfileInput) {
      configuration
        @appendNode(
          connections: $connections
          edgeTypeName: "ConfigurationEdge"
        ) {
        profile
        record {
          ... on ResourceOwnerConfiguration {
            default
            tags
          }
        }
      }
    }
  }
`;
